import angular from 'angular'
import uirouter from 'angular-ui-router'

import routing from './service.routes'
import ServiceService from './service.service'
import ServiceCard from './service-card.directive'
import ServiceFormDirective from './service-form.directive'
import ServiceCategoriesSlideoutDirective from './categories-slideout.directive'
import SubscriptionsSlideoutDirective from './subscriptions-slideout.directive'
import ServicesController from './services.controller'
import ServiceController from './service.controller'
import NewServiceController from './new-service.controller'
import './service.less'

export default angular.module('app.service', [uirouter, ServiceCard])
  .config(routing)
  .service('ServiceService', ServiceService)
  .directive('serviceForm', ServiceFormDirective)
  .directive('serviceCategoriesSlideout', ServiceCategoriesSlideoutDirective)
  .directive('subscriptionsSlideout', SubscriptionsSlideoutDirective)
  .controller('ServicesController', ServicesController)
  .controller('ServiceController', ServiceController)
  .controller('NewServiceController', NewServiceController)
  .name